import React from 'react';
import { Link } from 'react-router-dom';

const Ajuda: React.FC = () => {
  const categorias = [
    {
      icon: '👤',
      titulo: 'Conta e Perfil',
      descricao: 'Cadastro, login, configurações de conta',
      link: '/faq',
    },
    {
      icon: '📢',
      titulo: 'Anúncios',
      descricao: 'Como criar, editar e gerenciar anúncios',
      link: '/faq',
    },
    {
      icon: '💳',
      titulo: 'Pagamentos',
      descricao: 'Planos, formas de pagamento, faturas',
      link: '/faq',
    },
    {
      icon: '🔒',
      titulo: 'Segurança',
      descricao: 'Proteção de dados, denúncias, fraudes',
      link: '/faq',
    },
    {
      icon: '💬',
      titulo: 'Chat e Negociação',
      descricao: 'Como usar o chat, fazer ofertas',
      link: '/faq',
    },
    {
      icon: '⭐',
      titulo: 'Avaliações',
      descricao: 'Sistema de reputação, como avaliar',
      link: '/faq',
    },
  ];

  const artigosPopulares = [
    { titulo: 'Como criar meu primeiro anúncio', link: '/faq' },
    { titulo: 'Dicas para vender mais rápido', link: '/faq' },
    { titulo: 'Como funciona o sistema de destaque', link: '/faq' },
    { titulo: 'Política de devolução', link: '/termos' },
    { titulo: 'Como verificar minha conta', link: '/faq' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Central de Ajuda</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto mb-8">
            Como podemos ajudar você hoje?
          </p>
          
          {/* Search */}
          <div className="max-w-xl mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="Buscar na central de ajuda..."
                className="w-full px-6 py-4 rounded-xl text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-green-500 focus:outline-none"
              />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-green-700">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-custom py-12">
        {/* Categories */}
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Categorias de Ajuda</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {categorias.map((cat) => (
              <Link
                key={cat.titulo}
                to={cat.link}
                className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow group"
              >
                <div className="text-4xl mb-4">{cat.icon}</div>
                <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-green-700 transition-colors">
                  {cat.titulo}
                </h3>
                <p className="text-gray-600 text-sm">{cat.descricao}</p>
              </Link>
            ))}
          </div>
        </div>

        {/* Popular Articles */}
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Artigos Populares</h2>
          <div className="bg-white rounded-xl shadow-sm divide-y">
            {artigosPopulares.map((artigo) => (
              <Link
                key={artigo.titulo}
                to={artigo.link}
                className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 transition-colors"
              >
                <span className="text-gray-700">{artigo.titulo}</span>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            ))}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="max-w-3xl mx-auto mt-12">
          <div className="bg-green-50 rounded-2xl p-8 text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Precisa de mais ajuda?</h3>
            <p className="text-gray-600 mb-4">Nossa equipe de suporte está disponível para ajudar.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contato"
                className="px-6 py-3 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition-colors"
              >
                Falar com Suporte
              </Link>
              <Link
                to="/faq"
                className="px-6 py-3 border-2 border-green-700 text-green-700 rounded-lg font-semibold hover:bg-green-100 transition-colors"
              >
                Ver FAQ Completo
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ajuda;
